module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), (!_vm.initializing) ? _c('div', {
    staticClass: "container remove-margins"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-8 col-md-10 col-xs-12 remove-margins"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 remove-margins"
  }, [_c('div', [_c('div', {
    staticClass: "flex-container"
  }, _vm._l((_vm.petPhotoList), function(photo) {
    return _c('div', [_c('PetPicView', {
      key: photo.PetPhotoId,
      attrs: {
        "photoIdProp": photo.PetPhotoId
      }
    })], 1)
  })), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "image-preview-wrapper"
  }, [_c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    staticClass: "buttonPhoto",
    attrs: {
      "id": "imgPrev",
      "src": _vm.photoComp,
      "crossOrigin": "Anonymous"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "my-button"
  }, [_c('label', {
    staticClass: "btn btn-success btn-title"
  }, [_vm._v("\n                                                Photo "), _c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" "), _c('input', {
    staticClass: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "getImage",
      "type": "file",
      "accept": "image/jpeg, image/bmp, image/png"
    },
    on: {
      "change": _vm.previewThumbnail
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('div', {
    staticClass: "inner-addon right-addon"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petName')),
      expression: "errors.has('petName')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), (_vm.newPet.Name) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has('petName')),
      expression: "!errors.has('petName')"
    }],
    staticClass: "fa fa-paw text-success "
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.Name),
      expression: "newPet.Name"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'has-error': _vm.errors.has('petName')
    },
    attrs: {
      "type": "text",
      "name": "petName",
      "data-vv-as": "pet name",
      "placeholder": "Pet Name",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.newPet.Name)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.validateBeforeSubmit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPet, "Name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petName')),
      expression: "errors.has('petName')"
    }],
    staticClass: "help-inline text-danger h5"
  }, [_vm._v(_vm._s(_vm.errors.first('petName')))])]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-title btn-block",
    class: {
      active: _vm.newPet.PetType == 2, 'btn-danger': !_vm.PetTypeSelected
    },
    staticStyle: {
      "margin-top": "0px",
      "padding-right": "0px"
    },
    on: {
      "click": function($event) {
        _vm.updatePetType(2)
      }
    },
    model: {
      value: (_vm.newPet.PetType),
      callback: function($$v) {
        _vm.$set(_vm.newPet, "PetType", $$v)
      },
      expression: "newPet.PetType"
    }
  }, [_vm._v("Cat")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6",
    staticStyle: {
      "margin-top": "0px",
      "padding-left": "0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-title btn-block",
    class: {
      active: _vm.newPet.PetType == 1, 'btn-danger': !_vm.PetTypeSelected
    },
    staticStyle: {
      "margin-top": "0px",
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        _vm.updatePetType(1)
      }
    },
    model: {
      value: (_vm.newPet.PetType),
      callback: function($$v) {
        _vm.$set(_vm.newPet, "PetType", $$v)
      },
      expression: "newPet.PetType"
    }
  }, [_vm._v("Dog")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.Gender),
      expression: "newPet.Gender"
    }],
    attrs: {
      "type": "radio",
      "name": "male",
      "id": "male",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.newPet.Gender, "true")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.newPet, "Gender", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "h4",
    class: {
      'text-danger': !_vm.PetGenderSelectedComp
    },
    attrs: {
      "for": "male"
    }
  }, [_vm._v("Male")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6",
    staticStyle: {
      "margin-top": "0px",
      "padding-left": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.Gender),
      expression: "newPet.Gender"
    }],
    attrs: {
      "type": "radio",
      "id": "female",
      "name": "female",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.newPet.Gender, "false")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.newPet, "Gender", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "h4",
    class: {
      'text-danger': !_vm.PetGenderSelectedComp
    },
    attrs: {
      "for": "female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin-left": "0px !important",
      "padding-left": "0px"
    }
  }, [_c('label', [_vm._v("Age Years")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.AgeYears),
      expression: "newPet.AgeYears"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPet, "AgeYears", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 0 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v(" 5 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v(" 6 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(" 7 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v(" 8 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v(" 9 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v(" 10 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v(" 11 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v(" 12 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v(" 13 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v(" 14 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v(" 15 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    }
  }, [_c('label', [_vm._v("Age Months")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.AgeMonths),
      expression: "newPet.AgeMonths"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newPet, "AgeMonths", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 0 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v(" 5 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v(" 6 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v(" 7 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v(" 8 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v(" 9 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v(" 10 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v(" 11 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v(" 12 ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse col-sm-12 remove-margins",
    attrs: {
      "id": "petOptional"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 remove-margins"
  }, [_c('div', [_c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.IsRegisteredwithColar),
      expression: "newPet.IsRegisteredwithColar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPet.IsRegisteredwithColar) ? _vm._i(_vm.newPet.IsRegisteredwithColar, null) > -1 : (_vm.newPet.IsRegisteredwithColar)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPet.IsRegisteredwithColar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPet.IsRegisteredwithColar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPet.IsRegisteredwithColar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newPet, "IsRegisteredwithColar", $$c)
        }
      }
    }
  }), _vm._v("\n                             Does your pet have Munipicaty Colar and Registration?")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.IsNeuteredOrSpayed),
      expression: "newPet.IsNeuteredOrSpayed"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPet.IsNeuteredOrSpayed) ? _vm._i(_vm.newPet.IsNeuteredOrSpayed, null) > -1 : (_vm.newPet.IsNeuteredOrSpayed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPet.IsNeuteredOrSpayed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPet.IsNeuteredOrSpayed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPet.IsNeuteredOrSpayed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newPet, "IsNeuteredOrSpayed", $$c)
        }
      }
    }
  }), _vm._v("\n                            Is your Pet Neutered/Spayed?")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.TicksOrFleas),
      expression: "newPet.TicksOrFleas"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPet.TicksOrFleas) ? _vm._i(_vm.newPet.TicksOrFleas, null) > -1 : (_vm.newPet.TicksOrFleas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPet.TicksOrFleas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPet.TicksOrFleas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPet.TicksOrFleas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newPet, "TicksOrFleas", $$c)
        }
      }
    }
  }), _vm._v("\n                            Is your Pet clean from Ticks and Fleas?")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.RabiesVaccinated),
      expression: "newPet.RabiesVaccinated"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPet.RabiesVaccinated) ? _vm._i(_vm.newPet.RabiesVaccinated, null) > -1 : (_vm.newPet.RabiesVaccinated)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPet.RabiesVaccinated,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPet.RabiesVaccinated = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPet.RabiesVaccinated = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newPet, "RabiesVaccinated", $$c)
        }
      }
    }
  }), _vm._v("\n                            Has been Rabies Vaccinated?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.MicrochipId),
      expression: "newPet.MicrochipId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Microchip ID"
    },
    domProps: {
      "value": (_vm.newPet.MicrochipId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPet, "MicrochipId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.PreferredVet),
      expression: "newPet.PreferredVet"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Any preferred Vets in case of an emergency?"
    },
    domProps: {
      "value": (_vm.newPet.PreferredVet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPet, "PreferredVet", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPet.Remarks),
      expression: "newPet.Remarks"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "Anything the sitter should know about your pet? i.e alergies, medications, surgeries",
      "id": "comment"
    },
    domProps: {
      "value": (_vm.newPet.Remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPet, "Remarks", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px",
      "margin-right": "0px",
      "padding-right": "0px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#petOptional"
    }
  }, [_vm._v("\n                        Optional Details\n                ")]), _vm._v(" "), (_vm.editingMode == false) ? _c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.validateBeforeSubmit()
      }
    }
  }, [_vm._v("Save & Continue")]) : _vm._e(), _vm._v(" "), (_vm.editingMode == true) ? _c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    on: {
      "click": function($event) {
        _vm.validateUpdate()
      }
    }
  }, [_vm._v("Save & Continue")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "cropPetPhotoModal",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "max-width": "400px",
      "max-height": "300px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "300px"
    },
    attrs: {
      "id": "cropPetPhotoCropper",
      "src": _vm.uploadedImageSrcComp,
      "alt": "Picture",
      "crossorigin": ""
    }
  }), _vm._v(" "), (_vm.uploading) ? _c('div', {
    staticClass: "progress progress-image"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped",
    style: ({
      width: _vm.uploadCompletePct
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.uploadStatusPct))])])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-title btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveImage
    }
  }, [_vm._v("Save Image")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-title btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelSave
    }
  }, [_vm._v("Close")])])])])])])]) : _c('div', {
    staticClass: "container remove-margins"
  }, [_c('h2', [_vm._v("Initializing Pet Data")]), _vm._v(" "), _c('p', [_vm._v("Please refresh your browser if this page takes too long")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-success"
  }, [_c('strong', [_vm._v("Step 1: Upload Photo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-success"
  }, [_c('strong', [_vm._v("Step 2: Enter Pet Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-success"
  }, [_c('strong', [_vm._v("Step 3: Select Pet Type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-success",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('strong', [_vm._v("Step 4: Select Pet Gender")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-success",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('strong', [_vm._v("Step 5: Specify Age")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalLabel"
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" Add Pet Photo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "docs-preview clearfix"
  }, [_c('div', {
    staticClass: "img-preview"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a617507c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetRegistration/components/PetRegister.vue
// module id = 651
// module chunks = 2